<template>
  <v-classification-toolbar
    title="Tagueador"
    :classification="classification"
    :classifications="classifications"
    @toggle-sidebar="toggleSidebar"
  >
    <v-feature-selector />
    <v-feature-searcher />
    <v-feature-searcher-confirm />
  </v-classification-toolbar>
</template>

<script>
import { mapState } from "vuex";

import VClassificationToolbar from "@/components/toolbars/ClassificationToolbar.vue";
import VFeatureSearcher from "./FeatureSearcher.vue";
import VFeatureSearcherConfirm from './FeatureSearcherConfirm';
import VFeatureSelector from "./FeatureSelector.vue";

export default {
  components: {
    VClassificationToolbar,
    VFeatureSearcher,
    VFeatureSearcherConfirm,
    VFeatureSelector
  },
  computed: {
    ...mapState("ner", {
      classification: state => state.classification,
      classifications: state => state.classifications,
      show: state => state.show
    })
  },
  methods: {
    /**
     * Change the visibility of the sidebar.
     */
    toggleSidebar() {
      this.$store.commit("ner/setShowSidebar", !this.show.sidebar);
    }
  }
};
</script>
